import { createFileRoute } from '@tanstack/react-router';
import {
  CHOICES_PERMISSIONS,
  createPermissionGuard,
  getPermissionSet,
} from '@bmwe/ui';
import { ViewKassenzeichen } from '../../../features/kassenzeichen/viewKassenzeichen';

function ViewKassenzeichenRoute() {
  const { kassenzeichenId } = Route.useParams();
  return <ViewKassenzeichen kassenzeichenId={kassenzeichenId} />;
}

export const Route = createFileRoute(
  '/auswahlfelder/kassenzeichen/$kassenzeichenId',
)({
  component: ViewKassenzeichenRoute,
  beforeLoad: createPermissionGuard(
    getPermissionSet(CHOICES_PERMISSIONS, 'READ'),
  ),
});

export const ViewKassenzeichenRoute_ = Route;
